<div *ngFor="let item of sgoList; let i = index" class="m-b">
  <div (click)="item?.sgo?.length && item.isCollapsed = !item?.isCollapsed" [attr.aria-expanded]="item?.isCollapsed">
    <div class="well-none well-lg card card-block card-header" [ngClass]="{'active': item?.isCollapsed, 'well': item?.sgo?.length}">
      {{item?.name}} ({{item?.sgo?.length}})
    </div>
  </div>

  <div class="system-table table-container" [collapse]="!item?.isCollapsed" [isAnimated]="true">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Nº da Demanda</th>
            <th>Nº PROA</th>
            <th>Estabelecimento</th>
            <th>Município</th>
            <th>CROP</th>
            <th>Regional</th>
            <th>Tipo Demanda</th>
            <th>Situação</th>
            <th>Data Situação</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let itemSgo of item?.sgo; let sgoIndex = index">
            <tr>
              <td class="title">{{ itemSgo?.sgo_demanda_numero }}</td>
              <td>{{ itemSgo?.sgo_nro_processo }}</td>
              <td>{{ itemSgo?.sgo_imovel_nome }}</td>
              <td>{{ itemSgo?.sgo_imovel_municipio }}</td>
              <td>{{ itemSgo?.sgo_imovel_nro_crop }}</td>
              <td>{{ itemSgo?.sgo_solic_regional_se }}</td>
              <td>{{ itemSgo?.sgo_regional_tipo_demanda }}</td>
              <td>{{ itemSgo?.sgo_demanda_situacao_descricao }}</td>
              <td>{{ itemSgo?.sgo_data_situacao_atual }}</td>
              <td>
                <div class="btn-icon">
                  <span class="icon-table" (click)="infoSgo(itemSgo?.sgo_demanda_numero, i, sgoIndex)">
                    <img src="assets/images/svgs/Pesquisar.svg" alt="Mostrar Situação" tooltip="Mostrar Situação" placement="bottom">
                  </span>
                </div>
              </td>
            </tr>
            <tr *ngIf="itemSgo?.info && itemSgo?.isCollapsed">
              <td class="title" colspan="10" [innerHTML]="itemSgo?.info"></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>